import { FC } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import Complete from './Complete';
import Confirmation from './Confirmation';
import Upsell from './Upsell';

const Checkout: FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/upsell`} component={Upsell} />
    <Route path={`${match.url}/complete`} component={Complete} />
    <Route path={`${match.url}/confirmation`} component={Confirmation} />
  </Switch>
);

export default Checkout;
